import styled from "styled-components";
import { borderRadius } from "utils/theme";

export const Wrapper = styled.div``;

export const VideoWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  width: 100%;
  overflow: hidden;

  border-radius: ${borderRadius.regular}px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
  }
`;
